import React from 'react'
import Navigation from '../../components/Navigations/Navigation';
import TeamSection from '../../components/TeamAbout/TeamAbout';
import Footer from '../../components/Footer/Footer';
import OurLocation from '../../components/OurLocation/OurLocation';
import Slider from '../../components/SliderAbout/SliderAbout';


const AboutPage = () => {
  return (
    <div>
      <div>
        <Slider />
      </div>
    
      <div><Navigation />
      </div>
      <div>
        <TeamSection />
      </div>
  
       
      <div>
        <OurLocation />
      </div>
      <div>
        {/* <Footer /> */}
      </div>
    </div>
  )
}

export default AboutPage
